import RepairCategoryPage from "./RepairCategoryPage";

export default function IpadRepairPage() {
  return (
    <RepairCategoryPage
      category="ipad"
      eyebrow="iPad Reparatur"
      headline={<>iPad defekt?<br/><span className="text-zinc-500">Wir kümmern uns darum.</span></>}
      subline="Ob Display, Akku oder Ladebuchse — wir bringen dein iPad schnell und fachgerecht wieder in Bestform."
      accentColor="#DC1928"
    />
  );
}
